enum BlogEmbedType {
    audio = 'audio',
    video = 'video',
    url = 'url',
    html = 'html'
}

export default BlogEmbedType
